export var OrderGroupingFilter;
(function (OrderGroupingFilter) {
    OrderGroupingFilter[OrderGroupingFilter["All"] = 0] = "All";
    OrderGroupingFilter[OrderGroupingFilter["Group"] = 1] = "Group";
    OrderGroupingFilter[OrderGroupingFilter["Single"] = 2] = "Single";
})(OrderGroupingFilter || (OrderGroupingFilter = {}));
